import React from 'react';
import { DEMO_ENHANCEMENT_NOTES } from '../data/demoEnhancementNotes';

export default function DemoEnhancementPanel({ slug }) {
  const item = DEMO_ENHANCEMENT_NOTES[slug];
  if (!item) return null;

  return (
    <section className="rounded-xl border border-violet-500/25 bg-violet-950/20 p-6">
      <span className="text-xs font-mono uppercase tracking-wider text-violet-300 block mb-2">Extracted AI Studio enhancement</span>
      <p className="text-sm leading-relaxed text-blue-50 mb-4">{item.note}</p>
      <div className="rounded-lg border border-cyan-500/20 bg-cyan-950/20 p-4">
        <span className="text-[11px] font-mono uppercase tracking-wider text-cyan-300 block mb-1">Mobile / tablet usability rule</span>
        <p className="text-sm leading-relaxed text-blue-100">{item.mobile}</p>
      </div>
    </section>
  );
}
